import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { PrivacyPolicy } from "../../entity";

export class GetAllPrivacyPolicyDTO {
  @Expose()
  @ValidateNested()
  @Type(() => PrivacyPolicy)
  @IsArray()
  privacyPolicies!: PrivacyPolicy[];

  @Expose()
  @IsNumber()
  pageCount!: number;
}
